import type { CreateProjectRequest, ProjectSummary, UpdateProjectRequest } from '@todo/shared';
import { del, get, patch, post } from './client';

export const projectApi = {
  /** GET /api/projects - alphabetical; every signed-in user may read. */
  list(): Promise<ProjectSummary[]> {
    return get<ProjectSummary[]>('/projects');
  },

  /** POST /api/projects - admins only; 409 on a duplicate name. */
  create(body: CreateProjectRequest): Promise<ProjectSummary> {
    return post<ProjectSummary>('/projects', body);
  },

  /** PATCH /api/projects/:id - rename / edit description. Admins only. */
  update(
    id: string,
    body: UpdateProjectRequest,
  ): Promise<{ id: string; name: string; description: string | null }> {
    return patch<{ id: string; name: string; description: string | null }>(`/projects/${id}`, body);
  },

  /** DELETE /api/projects/:id - soft delete; tagged tasks keep their history. */
  remove(id: string): Promise<void> {
    return del(`/projects/${id}`);
  },
};
